const template = `
  <style>

    .price-progress__wrapper {
      text-align: center;
      display: grid;
      grid-template-columns: 1fr;
      gap: 8px;
      color: var(--color-white);
    }

    .price-progress__label {
      font-family: var(--font-main);
      font-weight: 400;
      font-size: 1.3rem;
      line-height: 18px;
      letter-spacing: 0.05rem;
      text-align: var(--price-progress-label-align, center);
      color: var(--color-text);
    }

    .price-progress__progress {
      border-radius: 8px;
      background-color: var(--color-white);
      width: 100%;
      display: block;
    }

    .price-progress__progress span {
      display: block;
      border-radius: inherit;
      height: var(--price-progress-height, .4rem);
      width: var(--progress-width, 0%);
      transition: 0.3s ease width;
      background-color: var(--color-white);
      box-shadow: 0 0 7px 3px var(--color-light-pink--dark);
    }
  </style>
  <div class="price-progress__wrapper">
    <span class="price-progress__label"></span>
    <span class="price-progress__progress">
      <span></span>
    </span>
  </div>
`
class PriceProgress extends HHBaseElement {
  constructor() {
    super(template)
    this.$label = this._shadowRoot.querySelector('.price-progress__label')
  }

  get labelPattern() {
    return this.getAttribute('label')
  }

  get completionLabel() {
    return this.getAttribute('complete-label')
  }

  get currencyCode() {
    if (this.getAttribute('show-currency-code') == 'false') {
      return ""
    }
    return Shopify.currency.active + " "
  }

  get label() {
    return this.labelPattern.replace(/###/i, this.currencyCode + Shopify.formatMoney(this.balance, window.money_format));
  }

  get balance() {
    return Math.abs(this.limit - this.value)
  }

  get value() {
    return Number(this.getAttribute('value'))
  }

  set value(value) {
    return this.setAttribute('value', value)
  }

  get limit() {
    return Number(this.getAttribute('limit')) || 0
  }

  set limit(limit) {
    return this.setAttribute('limit', limit)
  }

  get progress() {
    return this.value / this.limit
  }

  static get observedAttributes() {
    return ['value', 'limit', 'label', 'complete-label']
  }

  attributeChangedCallback() {
    this.applyState()
  }

  connectedCallback() {
    this.applyState()
  }

  applyState() {
    this.style.setProperty(
      '--progress-width',
      `${Math.min(isNaN(this.progress) ? 0 : this.progress, 1) * 100}%`
    )
    if (this.progress >= 1) {
      if (this.completionLabel) {
        this.$label.innerHTML = this.completionLabel
        this.style.display = ''
      } else {
        this.style.display = 'none'
      }
    } else {
      this.$label.innerHTML = this.label
      this.style.display = ''
    }
  }
}
window.customElements.define('price-progress', PriceProgress)
